import { VFC } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { ReactComponent as AdvaniaLogo } from '../static/advanialogo.svg';
import { Navigation } from './Navigation';

const SidebarWrapper = styled.aside`
    position: sticky;
    top: 0;
    height: 100vh;
    width: 300px;
    padding: ${props => props.theme.spacing[4]} ${props => props.theme.spacing[4]};
    display: flex;
    flex-direction: column;
    box-shadow: 0px 3px 25px rgba(0, 0, 0, 0.06);
`;

const LogoWrapper = styled(Link)`
    display: inline-block;
    margin-bottom: ${props => props.theme.spacing[12]};
    img {
        max-width: 130px;
    }
`;

const Logo = styled(AdvaniaLogo)`
    max-width: 130px;
`;

export const Sidebar: VFC = () => {
    return (
        <SidebarWrapper>
            <LogoWrapper to="/">
                <Logo />
            </LogoWrapper>
            <Navigation />
        </SidebarWrapper>
    );
};
